import { useState } from 'react';
import jobsData from '../../data/jobs.json';
import './JobsOpenRolesSection.css';
import ScanMyFitDrawer from './ScanMyFitDrawer';

const jobs = jobsData.jobs || [];
const browseByRoleCount = jobsData.counts?.browseByRole ?? 0;
const openJobsCount = jobsData.counts?.openJobs ?? jobs.length;
const focusTrack = jobsData.focusTrack || 'Copilot / Power Platform';
const updatedLabel = jobsData.updatedLabel || 'Updated weekly · hand-curated';

function JobsOpenRolesSection() {
  const [activeView, setActiveView] = useState('open');
  const [drawerJob, setDrawerJob] = useState(null);
  const jobCount = jobs.length;

  return (
    <section className="jobs-open-roles" aria-labelledby="jobs-open-roles-title">
      <div className="jobs-open-roles__inner">
        <div className="jobs-open-roles__switch" role="tablist" aria-label="Jobs board view">
          <button
            type="button"
            role="tab"
            className={`jobs-open-roles__switch-item ${activeView === 'roles' ? 'is-active' : ''}`}
            aria-selected={activeView === 'roles'}
            onClick={() => setActiveView('roles')}
          >
            Browse by role
            <span>{browseByRoleCount}</span>
          </button>
          <button
            type="button"
            role="tab"
            className={`jobs-open-roles__switch-item ${activeView === 'open' ? 'is-active' : ''}`}
            aria-selected={activeView === 'open'}
            onClick={() => setActiveView('open')}
          >
            Open jobs
            <span>{openJobsCount}</span>
          </button>
        </div>

        <div className="jobs-open-roles__meta-row">
          <h2 id="jobs-open-roles-title">{jobCount} open jobs in {focusTrack}</h2>
          <p>{updatedLabel}</p>
        </div>

        <div className="jobs-open-roles__grid">
          {jobs.map((job) => (
            <article className="job-role-card" key={job.id}>
              <div className="job-role-card__head">
                <div className="job-role-card__avatar" aria-hidden="true">{job.initials}</div>
                <div>
                  <h3>{job.title}</h3>
                  <p>{job.company}</p>
                </div>
              </div>

              <div className="job-role-card__tags" aria-label="Role metadata">
                <span>{job.location}</span>
                <span>{job.mode}</span>
                <span className="is-salary">{job.salary}</span>
              </div>

              <div className="job-role-card__benchmark">
                Benchmarked as <strong>{job.benchmarkTrack}</strong> · {job.benchmarkRole}
              </div>

              <div className="job-role-card__footer">
                <p>{job.updatedAgo}</p>
                <div className="job-role-card__actions">
                  <button type="button" className="job-role-card__btn job-role-card__btn--outline">Apply ↗</button>
                  <button type="button" className="job-role-card__btn job-role-card__btn--primary" onClick={() => setDrawerJob(job)}>Scan my fit →</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <ScanMyFitDrawer
        isOpen={!!drawerJob}
        job={drawerJob}
        onClose={() => setDrawerJob(null)}
      />
    </section>
  );
}

export default JobsOpenRolesSection;
